import { useBrowserEffect } from './useBrowserEffect.js';
import { useIsMounted } from './useIsMounted.js';

function useControlledOverlay(_ref) {
  var visible = _ref.visible,
    id = _ref.id,
    overlayList = _ref.overlayList,
    showFunction = _ref.showFunction,
    hideFunction = _ref.hideFunction;
  var isMounted = useIsMounted();
  useBrowserEffect(function () {
    if (visible === undefined) return function () {};
    if (visible && !overlayList.find(function (overlay) {
      return overlay.id === id;
    })) {
      showFunction();
    } else if (!visible && overlayList.find(function (overlay) {
      return overlay.id === id;
    })) {
      hideFunction();
    }
    return function () {
      if (!isMounted() && overlayList.find(function (overlay) {
        return overlay.id === id;
      })) {
        hideFunction();
      }
    };
  }, [visible, overlayList, id, showFunction, hideFunction, isMounted]);
}

export { useControlledOverlay };
//# sourceMappingURL=useControlledOverlay.js.map
